import { atom } from "jotai";
import {
  componentOptions,
  type ComponentName,
  type ComponentState,
} from "app/componentOptions";
import { createComponentController } from "lib/util/ComponentController";
import componentStackAtom from "./componentStackAtom";
import componentStackIdsAtom from "./ComponentStackIdsAtom";
import { requestCurrentStackEntryClose } from "./requestCurrenStackEntryClose";

const pushComponentToStack = atom<
  null,
  [ComponentState<ComponentName>],
  Promise<boolean>
>(
  null,
  async (
    get,
    set,
    { componentType, componentProps, uiProps = {}, componentId },
  ) => {
    const canLeaveCurrent = await requestCurrentStackEntryClose(get);

    if (!canLeaveCurrent) {
      return false;
    }

    const componentAtom = atom({
      componentId,
      componentType,
      componentProps,
      uiProps: {
        ...componentOptions[componentType].defaultUiOptions,
        ...uiProps,
      },
    });

    set(componentStackAtom, [
      ...get(componentStackAtom),
      {
        componentAtom,
        controller: createComponentController(componentId),
      },
    ]);

    set(componentStackIdsAtom, (ids: string[]) => [...ids, componentId]);

    return true;
  },
);

export default pushComponentToStack;
